import React, { ComponentProps } from 'react';
import { asFetchableBlock, useBlockContext } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import { DefaultView, DeleteAction, OptionalEditView, Views } from '../../types/BlockWithViews';
import { useSonTranslation } from '../../translation/useSonTranslation';
import {
  BlockInteractions,
  Views as BlockInteractionsViews,
  DISPLAY_TYPE,
  createButtonObject,
} from '../../components/organisms/BlockInteractions';
import { Icons } from '../../components/atoms/SVG';
import { Namespace } from '../../translation/namespace';
import { isNotNullOrUndefined } from '../../lib/typeGuards';
import { UserRegistrationPresetsDefaultView } from './views/UserRegistrationPresetsDefaultView';
import { UserRegistrationPresetsEditView } from './views/UserRegistrationPresetsEditView';

type UserRegistrationPresetsProps = Views<
  DefaultView<UserRegistrationPresetsDefaultView> & OptionalEditView<UserRegistrationPresetsEditView> & DeleteAction
>;

function UserRegistrationPresets({ views, activeView }: UserRegistrationPresetsProps) {
  const { t } = useSonTranslation('UserRegistrationPresets');
  const { uuid, elementType } = useBlockContext();

  const buttons = [
    views.delete &&
      createButtonObject(
        BlockInteractionsViews.DELETE,
        Icons.ERASER,
        `${Namespace.UserRegistrationPresets}:erase`,
        DISPLAY_TYPE.MODAL
      ),
    views.edit &&
      createButtonObject(
        BlockInteractionsViews.EDIT,
        Icons.EDIT_PENCIL,
        `${Namespace.UserRegistrationPresets}:edit`,
        DISPLAY_TYPE.COLLAPSIBLE,
        <UserRegistrationPresetsEditView {...views.edit} />
      ),
  ]
    .filter(isNotNullOrUndefined)
    .reduce((btn, elem) => ({ ...elem, ...btn }), {});

  return (
    <BlockInteractions
      headline={{
        text: t('headline'),
        visible: true,
        hierarchy: 3,
      }}
      alwaysShowInfo
      views={views}
      activeView={activeView}
      buttons={buttons}
      uuid={uuid}
      elementType={elementType}
    >
      <UserRegistrationPresetsDefaultView {...views.default} />
    </BlockInteractions>
  );
}

export const UserRegistrationPresetsBlock = asFetchableBlock(UserRegistrationPresets, BlockType.pluginconfiguration);
export type UserRegistrationPresetsBlock = ComponentProps<typeof UserRegistrationPresetsBlock>;
